export class ApprovePlanogramRequest {
  constructor(
    public planogramId: string,
    public stateId: string,
    public unapproveOthers: boolean
  ) {}
}